export default __webpack_public_path__ + "static/media/power2~bhsdlFjX.9aa33c34.svg";